<template>
  <v-container class="drop--overview--context__container pa-0">
    <v-row v-if="selectedShipment !== null" class="pa-0 drop--overview--context__layout">
      <ShipmentsContextShippedBy :isLoading="selectedShipment === 'loading'" :shipmentDetails="selectedShipment" />
      <v-col  class="drop--overview--context__component pa-2" cols="12">
        <ContextExpandList
        :title="$t('drops.drops')"
        :list="computeDropList"
        :isCustomSlot="true"
        :isHoverableActions="false"
        :closeOnSelect="false"
        >
          <template slot="customListElement" slot-scope="{ elementIndex }">
            <span class="context--expandlist__subtitle context--text--alignLeft col-20percent">
                  {{computeDropList[elementIndex].departure | timeToReadableTz($i18n.locale) }}-{{computeDropList[elementIndex].arrival | timeToReadableTz($i18n.locale) }}
            </span>
            <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
              {{computeDropList[elementIndex].destination.organization.name}}
            </span>
            <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
              {{computeDropList[elementIndex].destination.address.city}}, {{computeDropList[elementIndex].destination.address.countryCode}}
            </span>
            <span class="context--expandlist__subtitle context--text--alignRight col-20percent">
              {{computeDropList[elementIndex].weight | roundValueWeight(0)}} kg
            </span>
          </template>
        </ContextExpandList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContextExpandList from '@/components/wrld/generic/ContextExpandList.vue'
import ShipmentsContextShippedBy from '@/components/shipments/new/ShipmentsContextShippedBy.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ShipmentsDetailContext',
  components: {
    ShipmentsContextShippedBy,
    ContextExpandList
  },
  props: {},
  mounted () {},
  computed: {
    ...mapGetters([
      'getSelectedResourceID',
      'getShipmentResourceDrops',
      'getShipmentResourceDetails'
    ]),
    selectedShipment: function () {
      if (this.getShipmentResourceDetails === null) {
        return 'loading'
      }
      return this.getShipmentResourceDetails
    },
    computeDropList () {
      const drops = this.getShipmentResourceDrops != null ? this.getShipmentResourceDrops : []
      return drops
    }
  }
}
</script>
